export const CLEAR_PRODUCT_FROM_CART = 'CLEAR_PRODUCT_FROM_CART';

export const clearProductsFromCart = () => {
  return {
    type: CLEAR_PRODUCT_FROM_CART,
    payload: [],
  };
};
